<ion-item [lines]="lines">
  <ion-label class="ion-text-wrap" [style.border-color]="task.status.colorRgb">
    <h2>
      <strong>{{ task.Name }}</strong>
    </h2>
    <h3 *ngIf="isMonoMission">
      <strong>{{ task.ProjectType | projectType }}</strong>
    </h3>
    <h3>
      <strong>{{ task.event?.EventText }}</strong>
    </h3>
    <ion-chip color="primary">
      <h3>{{ task.StartDateUTC | sagaDate: 'SubmittedDateFormat' }} - {{ task.EndDateUTC | sagaDate: 'SubmittedDateFormat' }}</h3>
    </ion-chip>
    <h3>{{ task.location.FormattedLocation }}</h3>
  </ion-label>

  <ion-icon slot="end" name="location" (click)="locateMission($event)" size="large"></ion-icon>
</ion-item>
